// Tenantra Inc. - Shared helpers for the advanced analytics cards
export const money = (v) => (v == null ? '—' : `$${Math.round(Number(v)).toLocaleString('en-CA')}`);
export const pct = (v) => (v == null ? '—' : `${Number(v) % 1 ? Number(v).toFixed(1) : Number(v)}%`);
export const fmtDate = (v) => (v ? new Date(`${String(v).slice(0, 10)}T12:00:00`).toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');
export const plural = (n, w) => `${n} ${w}${n === 1 ? '' : 's'}`;
export const STATUS_LABEL = { on_time: 'On time', late: 'Late', partial: 'Partial', missed: 'Missed', paid: 'Paid', processing: 'Processing', unpaid: 'Not due yet', overdue: 'Overdue', unreported: 'Awaiting report' };

export function Card({ title, aside, children, testId, className = '' }) {
  return (
    <section className={`bg-white border border-slate-200 rounded-lg ${className}`} data-testid={testId}>
      <div className="px-5 pt-4 pb-3 flex items-baseline justify-between gap-3">
        <h3 className="text-sm font-medium text-slate-800">{title}</h3>
        {aside && <span className="text-xs text-slate-500 text-right">{aside}</span>}
      </div>
      {children}
    </section>
  );
}
